import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Utils } from '../../../../../../utils/utils';
import { DefaultValuesService } from '../../../../../../services/defaultvalues.service';
import { BE_ALLOWED_GROUP_FUNCTIONS } from '../../branchexcellence-admin.constants';

@Component({
    selector: 'createwavepopup',
    templateUrl: './createwavepopup.component.html',
    styleUrls: ['./createwavepopup.component.less'],
    standalone: false
})
export class CreateWavePopupComponent implements OnInit {
    form!: FormGroup
    constructor(
        public dialogRef: MatDialogRef<CreateWavePopupComponent>,
        private formBuilder: FormBuilder,
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private readonly toastrService: ToastrService,
        public defaults: DefaultValuesService) { }
    readonly waveGroupFunctions: string[] = [...BE_ALLOWED_GROUP_FUNCTIONS];

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            waveId: [this.data?.WaveId],
            name: [this.data?.Name, Validators.required],
            startDate: [this.data?.StartDate, Validators.required],
            endDate: [this.data?.EndDate, Validators.required],
            groupFunction: [{ value: this.data?.GroupFunction ?? this.defaults.groupFunction, disabled: !!this.data }, Validators.required],
        });
    }
    onSubmit() {
        // stop here if form is invalid
        if (this.form)
            if (this.form.invalid) {
                return;
            }

        Utils.httpUpsertWave(
            this.http
            , this.baseUrl
            , this.form.getRawValue()
            , this
            , function (tthis: CreateWavePopupComponent, result: any) {
                tthis.dialogRef.close({ event: 'submit' });
                if (result) {
                    tthis.toastrService.success('Wave was created successfully!');
                }
                else
                    tthis.toastrService.error('Wave could not be created. Please, contact with administrator');
            },
            null
        );
    }

    onDateChange(event: any, controlName: string) {
        const utcDate = Utils.dateUTCchange(event);
        this.form.get(controlName)?.setValue(utcDate);
    }

    backButtonHandler(event: any) {
        event.preventDefault();
        this.dialogRef.close();
    }
}
